import React from 'react';
import PropTypes from 'prop-types';
import Sound from 'react-sound';
import { observer } from 'mobx-react';
import StepHeader from '../step-header';
import StepWrapper from './step-wrapper';
import store from '../../stores/main';
import CircularProgress from './tone-step/circular-progress-bar';
var MAX_VOLUME = 70;
var VOLUMES_ARRAY = [10, 20, 30, 40, 50, 60, 70];
var ToneCalibrationAdjustVolumeStep = observer(function (_ref) {
  var content = _ref.content,
    onNextClick = _ref.onNextClick;
  var setVolume = function setVolume(volume) {
    store.setBaseVolume(volume);
  };
  var clickVolumeBar = function clickVolumeBar(e, volume) {
    e.preventDefault();
    setVolume(volume);
  };
  var increaseVolume = function increaseVolume(e) {
    e.preventDefault();
    var volume = store.baseVolume + 10;
    if (volume <= MAX_VOLUME) setVolume(volume);
  };
  var decreaseVolume = function decreaseVolume(e) {
    e.preventDefault();
    var volume = store.baseVolume - 10;
    if (volume > 0) {
      setVolume(volume);
    }
  };
  return /*#__PURE__*/React.createElement(StepWrapper, {
    backgroundImage: content.BackgroundImage,
    stepClassNames: "step--tone-calibration-adjust-volume"
  }, /*#__PURE__*/React.createElement("div", {
    className: "step__text"
  }, /*#__PURE__*/React.createElement(StepHeader, {
    icon: content.StepHeaderIcon,
    header: content.StepHeaderTitle
  }), /*#__PURE__*/React.createElement("div", {
    className: "tone-progress"
  }, /*#__PURE__*/React.createElement(CircularProgress, {
    sqSize: 60,
    strokeWidth: 10,
    percentage: 66,
    showPercentage: true
  })), /*#__PURE__*/React.createElement("p", {
    className: "step__title",
    dangerouslySetInnerHTML: {
      __html: content.Heading
    }
  }), /*#__PURE__*/React.createElement("p", {
    className: "step__body"
  }, content.Body), /*#__PURE__*/React.createElement(Sound, {
    url: content.SoundFile,
    playStatus: Sound.status.PLAYING,
    loop: true,
    volume: store.baseVolume
  }), /*#__PURE__*/React.createElement("div", {
    className: "volume-controls"
  }, /*#__PURE__*/React.createElement("div", {
    className: "step-circle-wrapper decrease ".concat(store.baseVolume <= 10 ? 'disabled' : '')
  }, /*#__PURE__*/React.createElement("button", {
    className: "step-circle",
    onClick: function onClick(e) {
      return decreaseVolume(e);
    },
    tabIndex: store.baseVolume <= 10 ? -1 : 0
  }, "\uE62D"), /*#__PURE__*/React.createElement("p", {
    className: "step-circle-label"
  }, content.SliderMinLabel)), /*#__PURE__*/React.createElement("div", {
    className: "volume-bars"
  }, VOLUMES_ARRAY.map(function (volume) {
    return /*#__PURE__*/React.createElement("button", {
      key: volume.toString(),
      onClick: function onClick(e) {
        return clickVolumeBar(e, volume);
      },
      className: "volume-bar ".concat(store.baseVolume >= volume ? 'filled' : 'empty')
    });
  })), /*#__PURE__*/React.createElement("div", {
    className: "step-circle-wrapper increase ".concat(store.baseVolume === MAX_VOLUME ? 'disabled' : '')
  }, /*#__PURE__*/React.createElement("button", {
    className: "step-circle",
    onClick: function onClick(e) {
      return increaseVolume(e);
    },
    tabIndex: store.baseVolume === MAX_VOLUME ? -1 : 0
  }, "\uE20E"), /*#__PURE__*/React.createElement("p", {
    className: "step-circle-label"
  }, content.SliderMaxLabel)))), /*#__PURE__*/React.createElement("div", {
    className: "step__buttons"
  }, /*#__PURE__*/React.createElement("button", {
    className: "step-button like-orange-button-large",
    onClick: function onClick(e) {
      e.preventDefault();
      onNextClick();
    }
  }, content.NextButtonLabel)));
});
ToneCalibrationAdjustVolumeStep.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  content: PropTypes.object.isRequired,
  onNextClick: PropTypes.func.isRequired
};
export default ToneCalibrationAdjustVolumeStep;